import { DashboardCustomizeOutlined } from "@mui/icons-material";
import {
  AiOutlineDashboard,
  AiOutlineDollarCircle,
  AiOutlineSetting,
} from "react-icons/ai";
import { BsBoxSeam } from "react-icons/bs";
import { IoIosMan } from "react-icons/io";

export const NAV_LINKS = [
  {
    screen: "dashboard",
    hasSubMenu: false,
    icon: <AiOutlineDashboard className="w-full h-full" />,
    link: "/dashboard",
  },
  {
    screen: "sales",
    hasSubMenu: true,
    icon: <AiOutlineDollarCircle className="w-full h-full" />,
    link: "/sales",
    sub_link: [
      {
        screen: "orders",
        link: "/sales/orders",
      },
      // {
      //     screen: 'invoices',
      //     link: '/sales/invoices',
      // },
      // {
      //     screen: 'returns',
      //     link: '/sales/returns',
      // },
      {
        screen: "taxes",
        link: "/sales/taxes",
        allowedRoles: ["admin"],
      },
      {
        screen: "reports",
        link: "/sales/reports",
      },
    ],
  },
  {
    screen: "customers",
    hasSubMenu: true,
    icon: <IoIosMan className="w-full h-full" />,
    link: "/customers",
    allowedRoles: ["admin"],
    sub_link: [
      {
        screen: "all customers",
        link: "/customers/all-customers",
      },
      {
        screen: "Business Applications",
        link: "/customers/business-applications",
      },
      {
        screen: "coupons",
        link: "/customers/coupons",
      },
    ],
  },
  {
    screen: "catalog",
    hasSubMenu: true,
    icon: <BsBoxSeam className="w-full h-full" />,
    link: "/catalog",
    sub_link: [
      {
        screen: "products",
        link: "/catalog/products",
      },
      {
        screen: "categories",
        link: "/catalog/category",
      },
      {
        screen: "Ingredients",
        link: "/catalog/ingredients",
      },
      {
        screen: "Product Concerns",
        link: "/catalog/concerns",
      },
      {
        screen: "Attribute Values",
        link: "/catalog/attribute-values",
      },
      {
        screen: "product uploads",
        link: "/catalog/product-uploads",
      },
      // {
      //   screen: "cash on delivery settings",
      //   link: "/catalog/cash-on-delivery-settings",
      // },
      {
        screen: "FAQs",
        link: "/catalog/faqs",
      },
    ],
  },
  // {
  //     screen: 'reports',
  //     hasSubMenu: true,
  //     icon: <VscGraphLine className='w-full h-full' />,
  //     link: '/reports',
  //     sub_link: []
  // },
  // {
  //     screen: 'system',
  //     hasSubMenu: true,
  //     icon: <AiOutlineSetting className='w-full h-full' />,
  //     link: '/system',
  //     sub_link: [{
  //         screen:'blogs',
  //         link:'/system/blogs'
  //     }]
  // },
  {
    screen: "Masters",
    hasSubMenu: true,
    icon: <DashboardCustomizeOutlined className="w-full h-full" />,
    link: "",
    allowedRoles: ["admin"],
    sub_link: [
      {
        screen: "brands",
        link: "/filters/brands",
      },
      {
        screen: "users",
        link: "/masters/users",
      },
      {
        screen: "certificates",
        link: "/masters/certificates",
      },
      {
        screen: "banners",
        link: "/masters/banners",
      },
    ],
  },
  {
    screen: "settings",
    hasSubMenu: true,
    icon: <AiOutlineSetting className="w-full h-full" />,
    link: "/settings",
    allowedRoles: ["admin"],
    sub_link: [
      {
        screen: "wallet",
        link: "/settings/wallet",
      },
      {
        screen: "order settings",
        link: "/settings/orders",
      },
      {
        screen: "threshold settings",
        link: "/settings/threshold",
      }
    ],
  },
];
